function getEnvVar<T>(key: string, defaultValue: string, formatter?: (val: string) => T): T {
  const value = process.env[key];
  if (value === undefined) return defaultValue as T;
  return formatter ? formatter(value) : (value as T);
}

export const envUtils = {
  SUPABASE_BASE_URL: getEnvVar<string>("SUPABASE_BASE_URL", ""),
  SUPABASE_ANON_KEY: getEnvVar<string>("SUPABASE_ANON_KEY", ""),
  API_BASE_URL: getEnvVar<string>("API_BASE_URL", ""),
  AUTH0_DOMAIN: getEnvVar<string>("AUTH0_DOMAIN", "studio-development.us.auth0.com"),
  AUTH0_CLIENT_ID: getEnvVar<string>("AUTH0_CLIENT_ID", ""),
  AUTH0_CLIENT_SECRET: getEnvVar<string>("AUTH0_CLIENT_SECRET", ""),
  AUTH0_AUDIENCE: getEnvVar<string>("AUTH0_AUDIENCE", "https://api.studio-development.com"),
  CADCHAT_APP_BASE_URL: getEnvVar<string>("CADCHAT_APP_BASE_URL", "http://localhost:3000"),
  MICROSOFT_CLIENT_ID: getEnvVar<string>("MICROSOFT_CLIENT_ID", ""),
  MICROSOFT_REDIRECT_URI: getEnvVar<string>("MICROSOFT_REDIRECT_URI", ""),
  MICROSOFT_ENCRYPTION_CERTIFICATE: getEnvVar<string>("MICROSOFT_ENCRYPTION_CERTIFICATE", ""),
  MICROSOFT_ENCRYPTION_CERTIFICATE_ID: getEnvVar<string>("MICROSOFT_ENCRYPTION_CERTIFICATE_ID", ""),
  SHOW_CONSOLE_LOGS: getEnvVar<string[]>("SHOW_CONSOLE_LOGS", "", (val: string) => {
    return val?.split("|")?.filter((k) => k !== "") ?? [];
  }),
  RELEASE_TYPE: getEnvVar<"development" | "production">("RELEASE_TYPE", "development"),
  VERSION_NUMBER: getEnvVar<string>("VERSION_NUMBER", ""),
};
